import { createFileRoute, redirect } from '@tanstack/react-router'

import { z } from 'zod'

import { StudioViewRenderer } from '@/pages/Studio/StudioViewRenderer'

const VALID_VIEWS = ['abstract', 'list'] as const

const studioSearchSchema = z.object({
  groupId: z.string().optional(),
  groupDetails: z.boolean().optional(),
})

export type StudioSearchParams = z.infer<typeof studioSearchSchema>

function StudioView() {
  const { view } = Route.useParams()

  return <StudioViewRenderer view={view} />
}

export const Route = createFileRoute('/_app/studio/$view')({
  component: StudioView,
  validateSearch: studioSearchSchema,
  beforeLoad: ({ params }) => {
    if (!VALID_VIEWS.includes(params.view as (typeof VALID_VIEWS)[number])) {
      throw redirect({
        to: '/studio/$view',
        params: { view: 'abstract' },
      })
    }
  },
})
